const avatars = [
  {
    name: 'Jenni',
    url: 'https://assets.bookmebob.com/images/avatars/Jenni.png',
  },
  {
    name: 'Novi',
    url: 'https://assets.bookmebob.com/images/avatars/Novi.png',
  },
  {
    name: 'Bob',
    url: 'https://assets.bookmebob.com/images/avatars/bob.png',
  },
  {
    name: 'Sarah',
    url: 'https://assets.bookmebob.com/images/avatars/Sarah.png',
  },
  {
    name: 'Wallis',
    url: 'https://assets.bookmebob.com/images/avatars/Wallis.png',
  },
];

export default avatars;
